import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GoogleButton } from "@/pages/AuthPages";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await register(name, email, password); toast.success("Welcome"); nav("/dashboard"); }
    catch (e) { const d = e.response?.data?.detail; setErr(typeof d === "string" ? d : "Registration failed"); }
    finally { setLoading(false); }
  };
  return (
    <section className="max-w-[520px] mx-auto px-6 py-24">
      <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">Create Account</p>
      <h1 className="font-serif text-5xl mt-2">Join BOLAWPRESS.</h1>
      <div className="mt-10"><GoogleButton /></div>
      <div className="my-8 flex items-center gap-4 text-xs font-mono tracking-[0.3em] uppercase text-[#888]">
        <div className="flex-1 h-px bg-[#E5E5E5]" /> or <div className="flex-1 h-px bg-[#E5E5E5]" />
      </div>
      <form onSubmit={submit} className="space-y-6">
        <div><label className="text-xs font-mono tracking-[0.3em] uppercase">Name</label>
          <input data-testid="reg-name" required value={name} onChange={e => setName(e.target.value)} className="mt-2 w-full border-b border-[#E5E5E5] focus:border-[#C5A059] outline-none py-3 bg-transparent" /></div>
        <div><label className="text-xs font-mono tracking-[0.3em] uppercase">Email</label>
          <input data-testid="reg-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2 w-full border-b border-[#E5E5E5] focus:border-[#C5A059] outline-none py-3 bg-transparent" /></div>
        <div><label className="text-xs font-mono tracking-[0.3em] uppercase">Password</label>
          <input data-testid="reg-password" type="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} className="mt-2 w-full border-b border-[#E5E5E5] focus:border-[#C5A059] outline-none py-3 bg-transparent" /></div>
        {err && <p className="text-sm text-[#9A1F1F]" data-testid="reg-error">{err}</p>}
        <button data-testid="reg-submit" disabled={loading} className="w-full bg-[#0a0a0a] text-white hover:bg-[#C5A059] hover:text-[#0a0a0a] transition-colors px-8 py-4 text-xs tracking-[0.25em] uppercase font-bold">{loading ? "Creating..." : "Create Account"}</button>
      </form>
      <p className="mt-8 text-sm text-[#555]">Already have an account? <Link to="/login" className="text-[#C5A059] font-bold" data-testid="link-login">Sign in</Link></p>
    </section>
  );
}
